import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import {
  mdiInformation,
  mdiChevronUp,
  mdiPause,
  mdiCheckboxMarkedOutline,
  mdiPaperclip,
  mdiCheck,
  mdiChevronRight,
  mdiChevronDown,
  mdiChevronLeft,
  mdiThumbUp,
  mdiEyeOff,
  mdiClose,
  mdiPauseCircle,
  mdiPlayCircle,
  mdiCamera,
  mdiContentCopy,
  mdiGoogle,
  mdiEye,
  mdiEyeOutline,
  mdiCheckboxBlankOutline,
  mdiPlus,
  mdiStar,
  mdiCloseBox,
  mdiPlay,
  mdiShare,
  mdiThumbUpOutline,
  mdiDotsVertical,
  mdiMenuDown,
  mdiMenuRight,
  mdiAccountGroup,
  mdiMagnify,
  mdiDownload,
  mdiSortVariant,
  mdiSortReverseVariant,
  mdiPoll,
  mdiCogOutline,
  mdiImage,
  mdiVideo,
  mdiFormatBold,
  mdiFormatItalic,
  mdiFormatUnderline,
  mdiFormatStrikethrough,
  mdiLink,
  mdiFormatListBulleted,
  mdiFormatListNumbered,
  mdiUndo,
  mdiRedo,
  mdiCheckCircle,
  mdiSwapHorizontal,
  mdiFilter,
  mdiFilterCheck,
  mdiAccountMultiple,
  mdiOpenInNew,
  mdiLinkVariant,
  mdiMenu,
  mdiArrowUp,
  mdiArrowDown,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiMagnifyMinusOutline,
  mdiMagnifyPlusOutline,
  mdiClockTimeFour,
  mdiTag,
  mdiCloseCircleOutline,
  mdiEmail,
  mdiRefresh,
  mdiLock,
  mdiPencil,
  mdiTriangle,
  mdiTriangleSmallDown,
  mdiTriangleSmallUp,
  mdiAt,
  mdiHome,
  mdiBookmark,
  mdiBorderHorizontal,
  mdiLightbulb,
  mdiDeleteOutline,
  mdiHistory,
  mdiPin,
  mdiFastForward10,
  mdiRewind10,
  mdiFolder,
  mdiFolderOpen,
  mdiMessageText,
  mdiListBoxOutline,
  mdiChatProcessingOutline,
  mdiImageSyncOutline,
} from "@mdi/js";

import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { fincsTheme } from "~/consts/VuetifyTheme";

export default defineNuxtPlugin(nuxtApp => {
  const vuetify = createVuetify({
    ssr: true,
    components,
    directives,
    theme: {
      defaultTheme: "fincsTheme",
      themes: {
        fincsTheme,
      },
    },
    icons: {
      defaultSet: "mdi",
      aliases: {
        ...aliases,
        mdiInformation,
        mdiChevronUp,
        mdiPause,
        mdiCheckboxMarkedOutline,
        mdiPaperclip,
        mdiCheck,
        mdiChevronRight,
        mdiChevronDown,
        mdiChevronLeft,
        mdiThumbUp,
        mdiEyeOff,
        mdiClose,
        mdiPauseCircle,
        mdiPlayCircle,
        mdiCamera,
        mdiContentCopy,
        mdiGoogle,
        mdiEye,
        mdiEyeOutline,
        mdiCheckboxBlankOutline,
        mdiPlus,
        mdiStar,
        mdiCloseBox,
        mdiPlay,
        mdiShare,
        mdiThumbUpOutline,
        mdiDotsVertical,
        mdiMenuDown,
        mdiMenuRight,
        mdiAccountGroup,
        mdiMagnify,
        mdiDownload,
        mdiSortVariant,
        mdiSortReverseVariant,
        mdiPoll,
        mdiCogOutline,
        mdiImage,
        mdiVideo,
        mdiFormatBold,
        mdiFormatItalic,
        mdiFormatUnderline,
        mdiFormatStrikethrough,
        mdiLink,
        mdiFormatListBulleted,
        mdiFormatListNumbered,
        mdiUndo,
        mdiRedo,
        mdiCheckCircle,
        mdiSwapHorizontal,
        mdiFilter,
        mdiFilterCheck,
        mdiAccountMultiple,
        mdiOpenInNew,
        mdiLinkVariant,
        mdiMenu,
        mdiArrowUp,
        mdiArrowDown,
        mdiFullscreen,
        mdiFullscreenExit,
        mdiMagnifyMinusOutline,
        mdiMagnifyPlusOutline,
        mdiClockTimeFour,
        mdiTag,
        mdiCloseCircleOutline,
        mdiEmail,
        mdiRefresh,
        mdiLock,
        mdiPencil,
        mdiTriangle,
        mdiTriangleSmallDown,
        mdiTriangleSmallUp,
        mdiAt,
        mdiHome,
        mdiBookmark,
        mdiBorderHorizontal,
        mdiLightbulb,
        mdiDeleteOutline,
        mdiHistory,
        mdiPin,
        mdiFastForward10,
        mdiRewind10,
        mdiFolder,
        mdiFolderOpen,
        mdiMessageText,
        mdiListBoxOutline,
        mdiChatProcessingOutline,
        mdiImageSyncOutline,
      },
      sets: {
        mdi,
      },
    },
  });
  nuxtApp.vueApp.use(vuetify);
});
